import { apiGet, apiPost, apiPut, apiDelete } from "./client";
import { buildListQuery, type CursorListParams } from "./pagination";

export interface ProviderConfig {
  providerId: string;
  type: "ats" | "board" | "local-parser";
  name: string;
  description: string;
  enabled: boolean;
  defaultConfig: Record<string, unknown>;
  userOverrides: Record<string, unknown>;
  urlPattern?: string;
  allowedHosts?: string[];
  supportsDetect?: boolean;
  supportsApiUrl?: boolean;
  features?: string[];
  timeoutMs?: number;
  retryPolicy?: string;
  website?: string;
  docsUrl?: string;
  createdAt?: string;
  updatedAt?: string;
  /** Computed by GET /api/providers from defaultConfig.scanner */
  scannable?: boolean;
  scannerAdapter?: string;
  skipReason?: string;
}

export interface ListProvidersResponse {
  providers: ProviderConfig[];
  total?: number;
  limit?: number;
  offset?: number;
  hasMore?: boolean;
  nextCursor?: string;
}

export async function listProviders(
  params?: CursorListParams,
): Promise<ListProvidersResponse> {
  return apiGet<ListProvidersResponse>(
    "/api/providers",
    buildListQuery(params as Record<string, string | number | boolean | undefined | null>),
  );
}

export async function getProvider(id: string): Promise<ProviderConfig> {
  const res = await apiGet<{ provider: ProviderConfig }>(`/api/providers/${id}`);
  return res.provider;
}

export async function updateProvider(id: string, updates: Partial<ProviderConfig>): Promise<ProviderConfig> {
  const res = await apiPut<{ provider: ProviderConfig }>(`/api/providers/${id}`, updates);
  return res.provider;
}

export async function discoverProviders(): Promise<{ discovered: number; providers: ProviderConfig[] }> {
  const res = await apiPost<{ message: string; seeded: string[] }>("/api/providers/discover");
  return { discovered: res.seeded?.length ?? 0, providers: [] };
}

export async function deleteProvider(id: string): Promise<void> {
  await apiDelete(`/api/providers/${id}`);
}